(() => {
  const SELECTORS = {
    countryButton: ".js-disclosure__button",
    countryList: ".js-disclosure-list",
    countryTemplate: ".js-localization-options-template",
    faqControl: ".js-accordion-control",
    faqContent: ".js-accordion-content",
    faqInner: ".js-accordion-inner",
    faqTemplate: ".js-faq-answer-template",
    productCard: ".js-product-card",
    productCardTemplate: ".js-product-card-actions-template",
    productTabButton: ".js-product-tabs-button",
    productTabProducts: ".product-tabs__products",
    productTabTemplate: ".js-product-tabs-template",
    looxLoadTarget: ".loox-rating, .loox-widget"
  };

  let productCardObserver;
  const observedCards = new WeakSet();

  function hydrateCountry(button) {
    const form = button.closest("localization-form");
    const list = form && form.querySelector(SELECTORS.countryList);
    const template = form && form.querySelector(SELECTORS.countryTemplate);

    if (!list || !template) return;

    list.append(template.content.cloneNode(true));
    template.remove();
  }

  function hydrateFaq(control) {
    const contentId = control.getAttribute("aria-controls");
    const content = contentId && document.getElementById(contentId);
    const inner = content && content.querySelector(SELECTORS.faqInner);
    const template = content && content.querySelector(SELECTORS.faqTemplate);

    if (!inner || !template) return;

    inner.append(template.content.cloneNode(true));
    template.remove();
  }

  function hydrateProductTab(button) {
    const panel = document.getElementById(button.dataset.id);
    const products = panel && panel.querySelector(SELECTORS.productTabProducts);
    const template = panel && panel.querySelector(SELECTORS.productTabTemplate);

    if (!products || !template) return;

    template.replaceWith(template.content.cloneNode(true));
    observeProductCards(panel);

    if (window.themeCore && window.themeCore.LazyLoadImages) {
      window.themeCore.LazyLoadImages.init();
    }

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit("compare-products:init");
    }
  }

  function hydrateProductCard(card) {
    const template = card.querySelector(SELECTORS.productCardTemplate);

    if (template) {
      template.replaceWith(template.content.cloneNode(true));
    }

    if (productCardObserver) {
      productCardObserver.unobserve(card);
    }
  }

  function observeProductCards(root = document) {
    root.querySelectorAll(SELECTORS.productCard).forEach((card) => {
      if (observedCards.has(card)) return;

      observedCards.add(card);

      if (productCardObserver) {
        productCardObserver.observe(card);
      } else {
        hydrateProductCard(card);
      }
    });
  }

  function initializeProductCardObserver() {
    if ("IntersectionObserver" in window) {
      productCardObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) hydrateProductCard(entry.target);
        });
      }, { rootMargin: "300px 300px" });
    }

    observeProductCards();
  }

  function initializeLoox() {
    const loadLoox = () => {
      const deferredLoad = window.__aevartDeferredLooxLoad;

      if (typeof deferredLoad !== "function") return;

      delete window.__aevartDeferredLooxLoad;
      deferredLoad.call(window);
    };
    const loadTarget = document.querySelector(SELECTORS.looxLoadTarget);

    if (!loadTarget || typeof window.__aevartDeferredLooxLoad !== "function") return;

    if (!("IntersectionObserver" in window)) {
      loadLoox();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      observer.disconnect();
      loadLoox();
    }, { rootMargin: "600px 0px" });

    observer.observe(loadTarget);
  }

  document.addEventListener("click", (event) => {
    const countryButton = event.target.closest(SELECTORS.countryButton);
    const faqControl = event.target.closest(SELECTORS.faqControl);
    const productTabButton = event.target.closest(SELECTORS.productTabButton);

    if (countryButton) hydrateCountry(countryButton);
    if (faqControl) hydrateFaq(faqControl);
    if (productTabButton) hydrateProductTab(productTabButton);
  }, true);

  const initialize = () => {
    initializeProductCardObserver();
    initializeLoox();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) observeProductCards(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
